import BaseBehavior from '../../../framework/base/base';
import { openWindow } from '../../../shared/utilities/openPopup';

export default class Dropdown extends BaseBehavior {
	constructor(element) {
		super(element);

		this.initDomCache();
		this.addEventListeners();
	}

	addEventListeners() {
		this.addEventListener(this.dom.select, 'change', e => {
			if (this.element.dataset.followLink) {
				e.preventDefault();
				this.followLink();
			}

			if (this.dom.label) {
				this.dom.label.innerHTML = e.target.options[e.target.selectedIndex].innerHTML;
			}
		});
	}

	removeEventListeners() {
		this.removeEventListener(this.dom.select, 'change');
	}

	followLink() {
		const option = this.dom.select.options[this.dom.select.selectedIndex];
		const link = option.value;
		const target = option.getAttribute('target');

		if (!link) {
			return;
		}

		if (target && target !== '') {
			openWindow(link, target);
		} else {
			const hashValue = this.element.dataset.focusWrapper || '';
			window.location.assign(`${link}${hashValue && '#' + hashValue}`);
		}
	}

	cleanup() {
		this.removeEventListeners();
	}
}
